// @flow
import { stringSort } from "../../element/Sort";
import { textOnlySearch } from "../../common/TextOnlySearch";

import type { SortFields } from "../../element/Sort";
import type { BbApiClient } from "../../../api/type.cli";
import type { SearchDefinition } from "../../element/Search";

export const clientSortFields: SortFields<BbApiClient> = {
    _default: stringSort<BbApiClient>('id'),
    id: stringSort<BbApiClient>('id'),
    permissions_group: stringSort<BbApiClient>('permissions_group'),
};
export const clientSearchDef: SearchDefinition<BbApiClient> = textOnlySearch<BbApiClient>('api_client');